// Must be an empty string for the logic to work all around the app
export const NO_TYPE_ID_KEY = '';

/**
 * Generates a deep link key based on the type and typeId
 * @param {string | undefined} type - The type of the deep link
 * @param {string | null | undefined} typeId - The typeId of the deep link
 * @returns {string} The generated deep link key
 */
const generateDeepLinkKey = (
  type: string | undefined,
  typeId: string | null | undefined,
) => `#type=${type}#typeId=${typeId ?? NO_TYPE_ID_KEY}`;

export default generateDeepLinkKey;
